"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 15/05/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var MnFullpageOptions = (function () {
    /**
     * Public default constructor
     *
     * @param options options js-object
     */
    function MnFullpageOptions(options) {
        if (options) {
            Object.assign(this, options);
        }
    }
    return MnFullpageOptions;
}());
exports.MnFullpageOptions = MnFullpageOptions;
//# sourceMappingURL=mnFullpage-options.class.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/components/fullpage/mnFullpage-options.class.js
// module id = ../../../../ngx-fullpage/components/fullpage/mnFullpage-options.class.js
// module chunks = 4